import React from 'react';
import { Box } from '@mui/material';
import useMediaQuery from '@mui/system/useMediaQuery';
import colors from '../../theme/colors';
import { breakpoints } from '../../theme';
import * as T from '../Typography';
import { InsightCardWrapper, IconWrapper } from './style';

type InsightCardProps = {
  title: string;
  content: string;
  btnLabel: string;
  imgSrc: string;
  onAction: () => void;
};

const InsightCard: React.FC<InsightCardProps> = ({
  onAction,
  title,
  content,
  imgSrc,
  btnLabel
}) => {
  const isWideScreen = useMediaQuery(`(min-width:${breakpoints.tablet}px)`);

  return (
    <InsightCardWrapper>
      <Box display="flex" flex={1}>
        <IconWrapper>
          <img src={imgSrc} alt="Survey Icon" />
        </IconWrapper>
        <Box
          flex={1}
          display="flex"
          flexDirection="column"
          mb={isWideScreen ? 0 : 3}
          ml={2}
        >
          <T.TextMediumBold color={colors.neutral.shades.shade700}>
            {title}
          </T.TextMediumBold>
          <Box flex={1} display="flex" flexDirection="column" justifyContent="space-between">
            <T.TextSmallRegular
              mt={2}
              color={colors.neutral.shades.shade600}
            >
              {content}
            </T.TextSmallRegular>
            <T.Link variant="blue" decoration="none" onClick={onAction}>
              {btnLabel}
            </T.Link>
          </Box>
        </Box>
      </Box>
    </InsightCardWrapper>
  );
};

export default InsightCard;
